import axios from 'axios';
import { debounce } from 'lodash';
import { registerPlanyoFormLoaded } from './modules/planyo-form-callbacks';
import { reset } from 'laravel-mix/src/Log';

const handleLoginLink = function(link) {
    link.addEventListener('click', (event) => {
        event.preventDefault();
        axios.get('/auth-check').then(response => {
            if (response.data.status === 'authenticated') {
                window.location.href = link.getAttribute('href');
                return;
            }
            document.querySelector('#login-modal').style.display = 'flex';
            const redirectInput = document.querySelector('#login-modal input[name="redirect"]');
            if (redirectInput) {
                redirectInput.value = link.getAttribute('href');
            } else {
                // Create the redirect hidden element and set the value
                const newRedirectInput = document.createElement('input');
                newRedirectInput.type = 'hidden';
                newRedirectInput.name = 'redirect';
                newRedirectInput.value = link.getAttribute('href');
                loginForm.appendChild(newRedirectInput);
            }
        }
        ).catch(error => {
            console.error('Error checking authentication:', error);
            alert('An error occurred while checking authentication. Please try again.');
        });
    });
};

const setupResourceDetailLoginButtons = function() {
    const rateBoxes = document.querySelectorAll('.wi-resource-details__widget');
    rateBoxes.forEach((rateBox) => {
        const observer = new MutationObserver((mutationsList) => {
            mutationsList.forEach((mutation) => {
                const rateBoxButtons = rateBox.querySelectorAll('.btn.btn-primary');
                rateBoxButtons.forEach((button) => {
                    if (!button.dataset.loginLinkBound) {
                        button.dataset.loginLinkBound = true;
                        handleLoginLink(button);
                    }
                });
            });
        });

        observer.observe(rateBox, {
            attributes: false,
            childList: true,
            subtree: true
        });
    });

};

const setupLoginButtons = function() {
    const searchResultButtons = document.querySelectorAll('#search-results .wi-btn.wi-btn--blue');
    searchResultButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
            event.preventDefault();
            axios.get('/auth-check').then(response => {
                if (response.data.status === 'authenticated') {
                    window.location.href = button.getAttribute('href');
                    return;
                }
                document.querySelector('#login-modal').style.display = 'flex';
                const redirectInput = document.querySelector('#login-modal input[name="redirect"]');
                if (redirectInput) {
                    redirectInput.value = button.getAttribute('href');
                } else {
                    // Create the redirect hidden element and set the value
                    const newRedirectInput = document.createElement('input');
                    newRedirectInput.type = 'hidden';
                    newRedirectInput.name = 'redirect';
                    newRedirectInput.value = button.getAttribute('href');
                    loginForm.appendChild(newRedirectInput);
                }
            }
            ).catch(error => {
                console.error('Error checking authentication:', error);
                alert('An error occurred while checking authentication. Please try again.');
            });
        });
    });
};

const setupLoginLinks = function() {
    const searchResultTimeLinks = document.querySelectorAll('#search-results .result_range a');
    searchResultTimeLinks.forEach(link => handleLoginLink(link));
};

const searchFiltersChanged = debounce(function() {
    if (typeof window.planyo_send_search_form == 'undefined') {
        console.error('window.planyo_send_search_form is not defined');
        return;
    }
    const searchResultsContainer = document.querySelector('.search-result-container');
    let hourglass = searchResultsContainer.querySelector('#hourglass_element');
    while (hourglass) {
        hourglass.remove();
        hourglass = searchResultsContainer.querySelector('#hourglass_element');
    }
    if (searchResultsContainer) {
        searchResultsContainer.insertAdjacentHTML('afterbegin', '<div id="hourglass_element"><div class="hourglass_img"></div></div>');
    }
    const searchResultsInner = searchResultsContainer.querySelector('#search-results');
    if (searchResultsInner) {
        searchResultsInner.style.display = 'none';
    }
    window.planyo_send_search_form();

}, 350, { leading: false, trailing: true });

const upcomingAvailabilityFiltersChanged = debounce(function() {
    if (typeof window.planyo_upcoming_availability_form_data_changed == 'undefined') {
        console.error('window.planyo_upcoming_availability_form_data_changed is not defined');
        return;
    }
    const searchResultsContainer = document.querySelector('.search-result-container');
    let hourglass = searchResultsContainer.querySelector('#hourglass_element');
    while (hourglass) {
        hourglass.remove();
        hourglass = searchResultsContainer.querySelector('#hourglass_element');
    }
    window.planyo_upcoming_availability_form_data_changed();

}, 350, { leading: false, trailing: true });

const setupUpcomingAvailabilityForm = function() {
    const searchForm = document.querySelector('#availability_form');
    if (!searchForm) {
        console.error('Search form not found #availability_form');
        return;
    }
    const planyoElements = searchForm.querySelectorAll('select');
    let arrayOfPlanyoElementLabelsAndValues = [];
    planyoElements.forEach((element) => {
        if (element.getAttribute('name') == 'prop_res_client') {
            return;
        }
        Array.from(element.options).forEach((option) => {
            const value = option.value;
            if (value == 'none' || value == '' || value == '---') {
                return;
            }
            const label = option.textContent.trim();
            const originalElement = element;
            arrayOfPlanyoElementLabelsAndValues.push({ label, value, originalElement });
        });
    });

    let filterContainer = document.querySelector('.wi-search-results__filters');
    // console.log('filterContainer', filterContainer);
    if (!filterContainer) {
        filterContainer = document.createElement('div');
        filterContainer.classList.add('wi-search-results__filters');
        searchForm.parentNode.insertBefore(filterContainer, searchForm.nextSibling);
    }
    arrayOfPlanyoElementLabelsAndValues.forEach((item) => {
        // Check to see if there is already an element with the same original element id and same value and skip if so
        const existingElements = filterContainer.querySelectorAll(`input[type="checkbox"][value="${item.value}"][data-original-element="${item.originalElement.id}"]`);
        if (existingElements.length > 0) {
            return;
        }
        const { label, value, originalElement } = item;
        const filterDiv = document.createElement('div');
        filterDiv.dataset.originalElement = originalElement.id;
        filterDiv.classList.add('wi-search-results__filter');
        const checkboxElement = document.createElement('input');
        checkboxElement.classList.add('wi-search-results__filter-checkbox');
        checkboxElement.type = 'checkbox';
        checkboxElement.value = value;
        checkboxElement.id = `filter-${originalElement.id}-${value}`;
        checkboxElement.setAttribute('data-original-element', originalElement.id);
        if (originalElement.value == value) {
            checkboxElement.checked = true;
        }
        // console.log('Adding event listener to checkboxElement', checkboxElement, originalElement.getAttribute('name'));
        checkboxElement.addEventListener('change', (event) => {
            const originalElementId = event.target.getAttribute('data-original-element');
            const originalElement = searchForm.querySelector(`#${originalElementId}`);
            // console.log('Checkbox changed', event.target, event.target.checked, originalElement.getAttribute('name'));
            if (!event.target.checked && originalElement && originalElement.getAttribute('name') == 'prop_res_client') {
                console.info('Cannot untick all client types');
                checkbox.checked = true;
                return;
            }
            // Untick other checkboxes with the same originalElementId
            const checkboxes = filterContainer.querySelectorAll(`input[type="checkbox"][data-original-element="${event.target.dataset.originalElement}"]`);
            checkboxes.forEach((checkbox) => {
                if (checkbox !== event.target) {
                    checkbox.checked = false;
                }
            });


            if (originalElement) {
                const optionToSelect = Array.from(originalElement.options).find(option => option.value === event.target.value);
                if (optionToSelect) {
                    optionToSelect.selected = event.target.checked;
                }
            }
            upcomingAvailabilityFiltersChanged();
        });
        const labelElement = document.createElement('label');
        labelElement.classList.add('wi-search-results__filter-label');
        labelElement.setAttribute('for', checkboxElement.id);
        if (label == 'Male Only') {
            labelElement.textContent = 'Male';
        } else if (label == 'Female Only') {
            labelElement.textContent = 'Female';
        } else if (label == 'Childrens Programming') {
            labelElement.textContent = 'Childrens\' Programming';
        } else {
            labelElement.textContent = label;
        }
        filterDiv.appendChild(checkboxElement);
        filterDiv.appendChild(labelElement);
        filterContainer.appendChild(filterDiv);
    });
    // Append a reset all button to the filter container if one doesn't already exist
    const resetButton = filterContainer.querySelector('.wi-search-results__filter-reset');
    if (arrayOfPlanyoElementLabelsAndValues.length == 0) {
        if (resetButton) {
            resetButton.style.display = 'none';
        }
        return;
    }
    if (!resetButton) {
        const resetAllButton = document.createElement('button');
        resetAllButton.classList.add('wi-search-results__filter-reset');
        resetAllButton.textContent = 'Reset Filters';
        resetAllButton.setAttribute('aria-label', 'Reset Filters');
        resetAllButton.setAttribute('type', 'button');

        const resetButtonIcon = document.createElement('img');
        resetButtonIcon.src = '/img/reset-filters.svg';
        resetButtonIcon.alt = 'Reset Filters';
        resetButtonIcon.classList.add('wi-search-results__filter-reset-icon');
        resetAllButton.appendChild(resetButtonIcon);

        resetAllButton.addEventListener('click', (event) => {
            event.preventDefault();
            const checkboxes = filterContainer.querySelectorAll('input[type="checkbox"]');
            checkboxes.forEach((checkbox) => {
                if (checkbox.getAttribute('name') == 'prop_res_client') {
                    console.log('Skipping unticking of prop_res_client checkbox to ensure at least one is always selected');
                    return;
                }
                checkbox.checked = false;
                const originalElementId = checkbox.getAttribute('data-original-element');
                const originalElement = searchForm.querySelector(`#${originalElementId}`);
                if (originalElement) {
                    const optionToSelect = Array.from(originalElement.options).find(option => option.value === checkbox.value);
                    if (optionToSelect) {
                        optionToSelect.selected = false;
                    }
                }
            });
            upcomingAvailabilityFiltersChanged();
        });
        filterContainer.appendChild(resetAllButton);
    }
};

// const inputsToIgnore = ['search_form', 'availability_form', 'search-results', 'wi-search-results__filters'];

const setupSearchForm = function() {
    const searchForm = document.querySelector('#search_form');
    if (!searchForm) {
        console.error('Search form not found #search_form');
        return;
    }
    const planyoElements = searchForm.querySelectorAll('select');
    let arrayOfPlanyoElementLabelsAndValues = [];
    planyoElements.forEach((element) => {
        if (element.getAttribute('name') == 'prop_res_client') {
            return;
        }
        Array.from(element.options).forEach((option) => {
            const value = option.value;
            if (value == 'none' || value == '' || value == '---') {
                return;
            }
            if (element.getAttribute('name') == 'prop_res_indoor_or_outdoor' && value == 'Both') {
                return;
            }
            const label = option.textContent.trim();
            const originalElement = element;
            arrayOfPlanyoElementLabelsAndValues.push({ label, value, originalElement });
        });
    });

    let filterContainer = document.querySelector('.wi-search-results__filters');
    // console.log('filterContainer', filterContainer);
    if (!filterContainer) {
        filterContainer = document.createElement('div');
        filterContainer.classList.add('wi-search-results__filters');
        searchForm.parentNode.insertBefore(filterContainer, searchForm.nextSibling);
    }
    arrayOfPlanyoElementLabelsAndValues.forEach((item) => {
        // Check to see if there is already an element with the same original element id and same value and skip if so
        const existingElements = filterContainer.querySelectorAll(`input[type="checkbox"][value="${item.value}"][data-original-element="${item.originalElement.id}"]`);
        if (existingElements.length > 0) {
            return;
        }
        const { label, value, originalElement } = item;
        const filterDiv = document.createElement('div');
        filterDiv.dataset.originalElement = originalElement.id;
        filterDiv.classList.add('wi-search-results__filter');
        const checkboxElement = document.createElement('input');
        checkboxElement.classList.add('wi-search-results__filter-checkbox');
        checkboxElement.type = 'checkbox';
        checkboxElement.value = value;
        checkboxElement.id = `filter-${originalElement.id}-${value}`;
        checkboxElement.setAttribute('data-original-element', originalElement.id);
        if (originalElement.value == value) {
            checkboxElement.checked = true;
        }
        checkboxElement.addEventListener('change', (event) => {
            const originalElementId = event.target.getAttribute('data-original-element');
            const originalElement = searchForm.querySelector(`#${originalElementId}`);
            if (!event.target.checked && originalElement && originalElement.getAttribute('name') == 'prop_res_client') {
                console.info('Cannot untick all client types');
                checkbox.checked = true;
                return;
            }
            // Untick other checkboxes with the same originalElementId
            const checkboxes = filterContainer.querySelectorAll(`input[type="checkbox"][data-original-element="${event.target.dataset.originalElement}"]`);
            checkboxes.forEach(checkbox => {
                if (checkbox !== event.target) {
                    checkbox.checked = false;
                }
            });

            if (originalElement) {
                const optionToSelect = Array.from(originalElement.options).find(option => option.value === event.target.value);
                if (optionToSelect) {
                    optionToSelect.selected = event.target.checked;
                }
            }
            searchFiltersChanged();
        });
        const labelElement = document.createElement('label');
        labelElement.classList.add('wi-search-results__filter-label');
        labelElement.setAttribute('for', checkboxElement.id);
        if (label == 'Male Only') {
            labelElement.textContent = 'Male';
        } else if (label == 'Female Only') {
            labelElement.textContent = 'Female';
        } else {
            labelElement.textContent = label;
        }
        filterDiv.appendChild(checkboxElement);
        filterDiv.appendChild(labelElement);
        filterContainer.appendChild(filterDiv);
    });
    // Append a reset all button to the filter container if one doesn't already exist
    const resetButton = filterContainer.querySelector('.wi-search-results__filter-reset');
    if (arrayOfPlanyoElementLabelsAndValues.length == 0) {
        if (resetButton) {
            resetButton.style.display = 'none';
        }
        return;
    }
    if (!resetButton) {
        const resetAllButton = document.createElement('button');
        resetAllButton.classList.add('wi-search-results__filter-reset');
        resetAllButton.textContent = 'Reset Filters';
        resetAllButton.setAttribute('aria-label', 'Reset Filters');
        resetAllButton.setAttribute('type', 'button');

        const resetButtonIcon = document.createElement('img');
        resetButtonIcon.src = '/img/reset-filters.svg';
        resetButtonIcon.alt = 'Reset Filters';
        resetButtonIcon.classList.add('wi-search-results__filter-reset-icon');
        resetAllButton.appendChild(resetButtonIcon);

        resetAllButton.addEventListener('click', (event) => {
            event.preventDefault();
            const checkboxes = filterContainer.querySelectorAll('input[type="checkbox"]');
            checkboxes.forEach((checkbox) => {
                if (checkbox.getAttribute('name') == 'prop_res_client') {
                    console.log('Skipping unticking of prop_res_client checkbox to ensure at least one is always selected');
                    return;
                }
                checkbox.checked = false;
                const originalElementId = checkbox.getAttribute('data-original-element');
                const originalElement = searchForm.querySelector(`#${originalElementId}`);
                if (originalElement) {
                    const optionToSelect = Array.from(originalElement.options).find(option => option.value === checkbox.value);
                    if (optionToSelect) {
                        optionToSelect.selected = false;
                    }
                }
            });
            searchFiltersChanged();
        });
        filterContainer.appendChild(resetAllButton);
    }
};

registerPlanyoFormLoaded(function(event) {
    window.verify_search_fields = "prop_res_client:Client,start_date:Start date";

    if (event == 'search_success') {
        const searchResultsContainer = document.querySelector('.search-result-container');
        const searchResults = searchResultsContainer.querySelector('#search-results');
        if (searchResults) {
            searchResults.style.display = 'block';
        }
        let hourglass = searchResultsContainer.querySelector('#hourglass_element');
        while (hourglass) {
            hourglass.remove();
            hourglass = searchResultsContainer.querySelector('#hourglass_element')
        }
    }

    setupLoginButtons();
    setupLoginLinks();
    setupSearchForm();
    setupUpcomingAvailabilityForm();

    const scrollToTopButton = document.querySelectorAll('.wi-search-results__update-search');
    scrollToTopButton.forEach((button) => {
        button.addEventListener('click', (event) => {
            event.preventDefault();
            let filterContainer = document.querySelector('.search-bar__bg');
            if (filterContainer) {
                filterContainer.scrollIntoView({
                    behavior: 'smooth'
                });
                return;
            }
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
    });
});

setupResourceDetailLoginButtons();